import axios from 'axios';
import normalAxios from '../baseConfig';
import hmacPlain from './hmacPlain';

const instance = axios.create({
    timeout: normalAxios.timeout, // 请求超时设置
    withCredentials: normalAxios.withCredentials // 跨域请求是否需要携带 cookie
});

instance.interceptors.request.use(
    function (request) {
        // 在发送请求之前做些什么
        const config = hmacPlain.sign(request, ['Referer']);
        return config;
    },
    function (error) {
        // 对请求错误做些什么
        return normalAxios.requestError(error);
    }
);

// // respone拦截器
instance.interceptors.response.use(
    (response) => {
        return normalAxios.response(response);
    },
    (error) => {
        return normalAxios.response(error);
        // return Promise.reject({ msg: '哈哈哈', error: error.response });
    }
);

export default instance;
